var ExtraTracking = {
  server: "https://api.extrapost.ru:5433",
  token: null,
  tracker_id: null,
  tracker: null,
  init(params) {
    this.server = params["server"] || this.server;
    this.token = params["token"];
    this.tracker_id = params["tracker_id"] || this.trackerIdFromHref();

    this.target = document.getElementById(params["target_id"]);
    this.addStyle();

    if (this.tracker_id) this.loadTracker();
  },
  addStyle() {
    var style = document.createElement("style");
    style.innerHTML =
      ".extrapost-tracking img.carrier-logo { height: 1em; margin-left: 0.5em; margin-bottom: -0.15em; display: inline; }" +
      ".extrapost-tracking ul { list-style: none; margin-bottom: 2em; margin-left: 1em; }" +
      ".extrapost-tracking ul li.location { margin-top: -1em; white-space: nowrap; }" +
      ".extrapost-tracking ul li.location div { display: inline-block; line-height: 0.95em; position: relative; top: 0.5em; }" +
      ".extrapost-tracking ul li.transit { margin-top: -0.5em; border-left: solid 3px green; height: 2em; }" +
      ".extrapost-tracking ul li.future-transit { margin-top: -0.5em; border-left: dashed 3px #aaa; height: 3em; }" +
      ".extrapost-tracking ul li.future-location::before { color: #aaa !important; }" +
      ".extrapost-tracking ul li.future-location { color: #aaa !important; }" +
      ".extrapost-tracking ul li.location::before { content: '⬤'; color: green; display: inline-block; margin-left: -0.45em; margin-right: 0.5em; position: relative; top: -0.05em; }";

    // Get the first script tag
    var ref = document.querySelector("script");

    // Insert our new styles before the first script tag
    ref.parentNode.insertBefore(style, ref);

    this.target.setAttribute("class", "extrapost-tracking");
  },
  loadTracker() {
    var xhr = this.createXHR(`trackers/${this.tracker_id}`);
    var self = this;
    xhr.onload = function() {
      if (xhr.responseText != "") {
        self.tracker = JSON.parse(xhr.responseText);
        console.log(self.tracker);
        self.formatHistory();
      }
    };
    xhr.send();
  },
  formatHistory() {
    this.target.innerHTML = `<h1>${this.tracker.tracking_code}<img class="carrier-logo" src="https://my.extrapost.ru/img/logos/${this.tracker.carrier}.svg"/></h1>`;

    if (this.tracker.tracking_history.length > 0) {
      var ul = document.createElement("ul");
      this.target.appendChild(ul);

      var li = null;
      this.tracker.tracking_history.forEach((op) => {
        li = document.createElement("li");
        li.innerHTML = `<div>${this.formatTimestamp(op.date, true)} ${op
          .location.name ||
          op.location.city ||
          ""} <br/>${op.operation}</div>`;
        li.setAttribute("class", "location");
        ul.appendChild(li);

        li = document.createElement("li");
        li.setAttribute("class", "transit");
        li.innerHTML = "&nbsp;";
        ul.appendChild(li);
      });

      if (
        this.tracker.status !== "delivered" &&
        this.tracker.status !== "available_for_pickup"
      ) {
        // Change last li class
        li.setAttribute("class", "future-transit");

        // Add final destination
        li = document.createElement("li");
        li.setAttribute("class", "location future-location");
        li.innerText = `${this.formatTimestamp(
          this.tracker.extra.est_delivery_date,
          false
        ) || ""} ${this.tracker.extra.dest_address || ""} — Прибытие`;
        ul.appendChild(li);
      } else {
        ul.removeChild(li);
      }
    } else {
      var p = document.createElement("p");
      p.innerText = "Пока нет информации по данному заказу. Зайдите попозже.";
      this.target.appendChild(p);
    }
  },
  trackerIdFromHref() {
    var q = this.query(window.location.search);
    return q["tracker"] || Object.keys(q)[0];
  },
  formatTimestamp(date, withTime) {
    if (date) {
      var d = new Date(Date.parse(date));

      var str = d.toLocaleString("ru-RU", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
      });

      if (d.getHours() !== 0 && d.getMinutes() !== 0 && withTime)
        str +=
          " " +
          d.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          });

      return str;
    } else {
      return null;
    }
  },
  query(search) {
    return Object.assign.apply(
      null,
      search
        .slice(1)
        .split("&")
        .map((entry) => ({ [entry.split("=")[0]]: entry.split("=")[1] }))
    );
  },
  createXHR(url) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", this.server + `/v1/${url}`);
    xhr.setRequestHeader("Authorization", "Basic " + this.token);
    return xhr;
  },
};

window.ExtraTracking = ExtraTracking;
